// @ts-strict

import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ISingleCampaign, SpecialCampaignData, ICampaignType } from '@app/core/models/core-models';
import { isArray, isEqual } from 'lodash';

@Component({
  selector: 'app-campaign-type-and-commision',
  templateUrl: './campaign-type-and-commision.component.html',
  styleUrls: ['./campaign-type-and-commision.component.scss']
})
export class CampaignTypeAndCommisionComponent implements OnInit, OnChanges {
  @Input() campaign?: ISingleCampaign | SpecialCampaignData;
  @Input() layout = '';

  public campaignTypes: ICampaignType[] = [];

  public get listLayout(): boolean {
    return this.layout === 'list';
  }

  ngOnInit(): void {
    this.assignCampaignType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.campaign?.previousValue &&
      changes.campaign?.currentValue &&
      !isEqual(changes.campaign?.previousValue.type, changes.campaign?.currentValue.type)
    ) {
      this.assignCampaignType();
    }
  }

  private assignCampaignType() {
    this.campaignTypes = isArray(this.campaign?.type) ? this.campaign!.type : [];
  }
}
